/**
 * LandSizeIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LandSizeIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23 2a1 1 0 1 0-2 0H9a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0h12a1 1 0 1 0 2 0zM1 8a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2v12a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2V9a1 1 0 0 1-1-1" />
    <path
      fillRule="evenodd"
      d="M7 9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zm2 0h12v12H9z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LandSizeIcon = makeIcon('LandSizeIcon', LandSizeIconSvg)
